(function (app) {

    app.directive("checkList", ["_",
        function (_) {
            return {
                scope: {
                    list: "=checkList",
                    value: "=",
                    options: "="
                },
                link: function (scope, elem) {
                    var handler = function (setup) {
                        if (!scope.list) scope.list = [];

                        var checked = elem.prop("checked");
                        var index;

                        if (scope.options && scope.options.Property) {
                            index = _.findIndex(scope.list,
                                function(row) {
                                    return row[scope.options.Property] === scope.value[scope.options.Property];
                                });
                        } else {
                            index = scope.list.indexOf(scope.value);
                        }

                        if (checked && index === -1) {
                            if (setup) elem.prop("checked", false);
                            else scope.list.push(scope.value);
                        } else if (!checked && index !== -1) {
                            if (setup) elem.prop("checked", true);
                            else scope.list.splice(index, 1);
                        }
                    };

                    var setupHandler = handler.bind(null, true);
                    var changeHandler = handler.bind(null, false);

                    elem.on("change",
                        function () {
                            scope.$apply(changeHandler);
                        });

                    scope.$watch("list", setupHandler, true);
                }
            }
        }]);

})(window.app); //jshint ignore:line